import React, { useEffect, useState } from "react";
import styles from "./reviewSharedData.module.scss";
import "./reviewSharedData.module.scss";
import Breadcrumbs from "../../components/breadcrumbs/Breadcrumbs";
import { Helmet } from "react-helmet";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { productApi } from "../../api/productApi";
import sharedDataApi from "../../api/sharedDataApi";
import { generateReviewData } from "../../utilities/helperMethods";
import RenderData from "./RenderData";
import { useSelector, useDispatch } from "react-redux";
import { setComments, setActionItemData, addComment, deleteComment } from "./reviewSharedDataSlice";
import Button from "../../components/button/Button";
import { RxUpdate } from "react-icons/rx";
import { RiArrowGoBackFill } from "react-icons/ri";
import { AiOutlineCheckCircle, AiOutlineCloseCircle } from "react-icons/ai";
import { selectUser } from "../../app/appSlice";
import Popup from "../../components/popUp/Popup";
import { sendSdpEmailNotification, requestProductionApproval, pushToProduction, reAssignToStaging } from "../sharedData/sharedDataSlice";
import { executeProductionOperations } from "../../services/moveToProductionService";
import { executeCoolCloudOperations } from "../../services/CoolCloudService";
import { useRef } from "react";

const ReviewSharedData = () => {
  const [productData, setProductData] = useState({});
  const [recipeInputFields, setRecipeInputFields] = useState({});
  const [recipeData, setRecipeData] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const [searchParam, _] = useSearchParams();
  const comments = useSelector((state) => state.reviewSharedData.comments);
  const dispatch = useDispatch();
  let [productId, setProductId] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [popupText, setPopupText] = useState("");
  const [popupAction, setPopupAction] = useState(null); // "approve" | "reject" | "moveToProduction" | "coolCloudProduction" | "requestProductionApproval"
  const [moveToProductionDisabled, setMoveToProductionDisabled] = useState(false);
  const [moveToProductionResult, setMoveToProductionResult] = useState(null);
  const tab = searchParam.get("tab") || "incoming";
  const [rejectionReason, setRejectionReason] = useState("");
  const [showRejectionPopup, setShowRejectionPopup] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const lastSelfActionTimeRef = useRef(0);
  const productDataRef = useRef({});
  const productIdRef = useRef(null);
  const [newCommentNotification, setNewCommentNotification] = useState(null);
  const lastCommentActionTimeRef = useRef(0);
  const [expiryDays, setExpiryDays] = useState("");

  const currentUser = useSelector(selectUser);
  const actionItem = useSelector(
    (state) => state.reviewSharedData.actionItemData
  );

  const navigate = useNavigate();
  const sdStates = Object.freeze({
    draft: "Draft",
    inReview: "In_Review",
    staging: "Staging",
    preProd: "Pre_Prod",
    production: "Production",
  });

  const updateProductSD = () => {
    setLoading(true);
    const actionId = searchParam.get("id");
    navigate(
      `/products/update-shared-data?id=${productId}&actionId=${actionId}`
    );
  };

  const fetchActionItemDetails = async () => {
    try {
      const actionId = searchParam.get("id");
      const item = await sharedDataApi.getActionItemById(actionId);

      if (!item) {
        throw new Error(`No action item found for id: ${actionId}`);
      }

      dispatch(setActionItemData(item));
      setProductId(item.ProductId);
      productIdRef.current = item.ProductId;
      setLoading(false);

      if (item.Status === "REJECTED") {
        setShowRejectionPopup(true); // moved after dispatch
      }
    } catch (e) {
      console.error("Error fetching action item:", e);
      setLoading(false);
      dispatch(setActionItemData({}));
      navigate("/dashboard");
    }
  };

useEffect(() => {
  if (!actionItem?.id || !productId) return;

  const actionItemSub = sharedDataApi.subscribeToActionItemUpdate(
    actionItem.id,
    async (updated) => {

      const isSelfAction = Date.now() - lastSelfActionTimeRef.current < 10000;

      if (isSelfAction) {
        console.log("Ignoring self ActionItem update");
        return;
      }

      console.log("ActionItem updated:", updated);

      await fetchActionItemDetails();

      if (actionItem.Status === "IN_REVIEW") {
        alert("This model was updated by another user. Please reload the page.");
      }    
    }
  );

  const productSub = sharedDataApi.subscribeToProductUpdate(
    productId,
    async (updated) => {

      const isSelfAction = Date.now() - lastSelfActionTimeRef.current < 10000;

      if (isSelfAction) {
        console.log("Ignoring self Product update");
        return;
      }

      console.log("Product updated:", updated);

      const currentProductData = productDataRef.current;
      const previousCoolCloudAck = currentProductData?.CoolCloudDBAck;
      const previousAMSAck = currentProductData?.AMSAck;
      const newCoolCloudAck = updated?.CoolCloudDBAck;
      const newAMSAck = updated?.AMSAck;
      const currentState = currentProductData?.State;

      // Detect relevant Pre_Prod state changes and refresh data
      if (currentState === "Pre_Prod") {
        if ((!previousCoolCloudAck && newCoolCloudAck) ||
            (!previousAMSAck && newAMSAck) ||
            updated?.State === "Staging" ||
            updated?.State === "Production") {
          await fetchActionItemDetails();
          await loadProductInfo();
          return;
        }
      }

      await loadProductInfo();
      if (actionItem.Status === "IN_REVIEW") {
        alert("This model was updated by another user. Please reload the page.");
      }
    }
  );

  return () => {
    actionItemSub.unsubscribe();
    productSub.unsubscribe();
  };
}, [actionItem?.id, productId]);

  useEffect(() => {
    fetchActionItemDetails();
  }, []);

  useEffect(() => {
    if (productId) {
      loadProductInfo();
      productId = null;
    }
  }, [productId]);

  const loadProductInfo = async () => {
    const currentProductId = productId || productIdRef.current;
    if (!currentProductId) return; 
    try {
      console.log("Searching for product with ID:", currentProductId); //Log the ID being searched

      const productInfo = await productApi.searchProducts({
        filter: { id: { eq: currentProductId } },
      });

      if (!productInfo?.items?.length) {
        console.error(`No products found for id: ${productId}`);
        throw new Error(`No products found for id: ${productId}`);
      }

      console.log("Product found:", productInfo.items[0]); //Log the product if found
      setProductData(productInfo.items[0]);
      productDataRef.current = productInfo.items[0];
      setLoading(false);
    } catch (e) {
      console.error("Error loading product info:", e); //Log the full error
      setLoading(false);
      setProductData({});
      if (actionItem?.Status !== "REJECTED") {
        navigate("/dashboard");
      }
    }
  };

  useEffect(() => {
    if (productData.id) {
      const fetchRecipeData = async () => {
        try {
          const recipeTemplateData = await sharedDataApi.getRecipeTemplate({
            Name: productData.Recipe,
          });
          const template = JSON.parse(recipeTemplateData.Recipe);
          setRecipeData(template);
          setLoading(false);
        } catch (error) {
          setLoading(false);
        }
      };
      fetchRecipeData();
    }
  }, [productData]);

  useEffect(() => {
    if (productData.id) {
      const fetchRecipeInputFields = async () => {
        const currSdState = productData.State;
        let params = {};
        setLoading(true);
        try {
          params = {
            ModelNumber: productData.ModelNumber,
            State: { eq: currSdState },
            limit: 10000,
          };
          if (
            currSdState === sdStates.staging ||
            currSdState === sdStates.production
          ) {
            const versionField = `${currSdState}Version`;
            params["filter"] = {
              Version: { eq: productData[versionField] },
            };
          }
          const userInputs = await sharedDataApi.fetchModelNumberByState(
            params
          );
          setRecipeInputFields([actionItem]);
          setLoading(false);
        } catch (error) {
          setLoading(false);
        }
      };

      fetchRecipeInputFields();
    }
  }, [productData]);

  useEffect(() => {
    if (
      !isEmpty(productData) &&
      !isEmpty(recipeData) &&
      !isEmpty(recipeInputFields)
    ) {
      const inputFields = JSON.parse(recipeInputFields[0].Input);
      
   // Filter recipeData to remove fields with type "JsonByteMatch"
    const filteredRecipeData = recipeData.filter(item => {
      return !item || item.type !== "JsonByteMatch";
    });
    
    const data = generateReviewData(productData, inputFields, filteredRecipeData);
      setData(data);
    }
  }, [productData, recipeData, recipeInputFields]);

  useEffect(() => {
    const fetchcomments = async () => {
      const actionId = searchParam.get("id");
      let allComments = [];
      let nextToken = null;
      try {
        do {
          const commentList = await sharedDataApi.listComments({
            filter: { actionId: { eq: actionId } },
            limit: 1000,
            nextToken,
          });
          allComments = [...allComments, ...(commentList?.items || [])];
          nextToken = commentList?.nextToken || null;
        } while (nextToken);
      } catch (e) {
        console.error("Error fetching comments:", e);
      }
      dispatch(setComments(allComments));
    };
    fetchcomments();
  }, []);

  // Real-time comment subscription
  useEffect(() => {
    const actionId = searchParam.get("id");
    if (!actionId) return;

    const commentCreateSub = sharedDataApi.subscribeToCommentUpdates(
      actionId,
      (newComment) => {
        
        // Skip if this comment was created by the current user (already added locally)
        if (newComment.name === currentUser?.email) {
          return;
        }
        dispatch(addComment(newComment));

        alert(`${newComment.name} added a new comment on "${newComment.property_name}"`);

      }
    );

    const commentDeleteSub = sharedDataApi.subscribeToCommentDeletes(
      actionId,
      (deletedComment) => {
        if (deletedComment.name === currentUser?.email) {
          return;
        }
        dispatch(deleteComment(deletedComment));
        alert(`${deletedComment.name} deleted a comment on "${deletedComment.property_name}"`);

      }
    );

    return () => {
      commentCreateSub.unsubscribe();
      commentDeleteSub.unsubscribe();
    };
  }, [searchParam, dispatch, currentUser?.email]);

  const isEmpty = (obj) => Object.keys(obj).length === 0;

  // Use the reusable thunk for sending review emails
  const sendReviewEmailNotification = async (status, updatedReasonForRejection, actionItemOverride) => {
    const item = actionItemOverride || actionItem;
    let userNameToUse = item?.CreatedByEmail || "Unknown User";
    if (item?.CreatedByEmail) {
      try {
        const userRes = await sharedDataApi.listSdpUsers({
          filter: { Email: { eq: item.CreatedByEmail } }
        });
        const user = (userRes?.items || []).find(
          u => u.Email?.toLowerCase() === item.CreatedByEmail.toLowerCase()
        );
        if (user && user.Name) userNameToUse = user.Name;
      } catch {
        userNameToUse = item.CreatedByEmail;
      }
    }
    let changedFields = [];
    try {
      const currInputs = item?.Input ? JSON.parse(item.Input) : {};
      changedFields = Object.keys(currInputs)
      .filter(key => {
          const fieldDef = recipeData?.find(f => f.fieldName === key);
          // Only include if field type is "input"
          return !fieldDef || fieldDef.type === "input";
        })
      .map(key => ({
        name: key,
        previousInput: "-",
        newInput: currInputs[key] !== undefined ? currInputs[key] : "-"
      }));
    } catch {}

    const currentUserEmail = (currentUser?.email || "").toLowerCase();
    const creatorEmail = (item?.CreatedByEmail || "").toLowerCase();
    const reviewerEmails = Array.isArray(item?.ReviewerEmails) 
      ? item.ReviewerEmails.map(e => e.toLowerCase())
      : [(item?.ReviewerEmail || "").toLowerCase()].filter(Boolean);

    // Determine recipients (To), CC, and sender (From) based on action type
    let toEmails = [];
    let ccEmails = [];
    let fromEmail = currentUserEmail;

    // Actions performed by reviewer/admin - notify creator, CC other reviewers + performer
    const reviewerActions = ["approved", "rejected", "reassigned", "production"];
    
    // Actions performed by creator - notify reviewers, CC creator
    const creatorActions = ["productionApprovalRequested"];

    if (reviewerActions.includes(status)) {
      // Reviewer/Admin performing action
      // To: Creator
      // CC: All reviewers (including performer for visibility)
      toEmails = [creatorEmail];
      ccEmails = [...reviewerEmails];
      // Ensure performer is in CC for visibility
      if (!ccEmails.includes(currentUserEmail)) {
        ccEmails.push(currentUserEmail);
      }
      fromEmail = currentUserEmail;
    } else if (creatorActions.includes(status)) {
      // Creator performing action (Request for Production Approval)
      // To: All reviewers
      // CC: Creator (performer)
      toEmails = reviewerEmails.filter(email => email !== creatorEmail);
      ccEmails = [creatorEmail]; // Creator in CC
      fromEmail = currentUserEmail;
    } else {
      // Default behavior for other statuses
      toEmails = [creatorEmail];
      ccEmails = [...reviewerEmails];
      if (!ccEmails.includes(currentUserEmail)) {
        ccEmails.push(currentUserEmail);
      }
      fromEmail = currentUserEmail;
    }

    // Remove any empty strings or duplicates
    toEmails = [...new Set(toEmails.filter(Boolean))];
    ccEmails = [...new Set(ccEmails.filter(Boolean))];

    const formatReasonForChange = (reasonForChange) => {
      if (!reasonForChange) return "-";

      try {
        const parsed = typeof reasonForChange === "string" 
          ? JSON.parse(reasonForChange) 
          : reasonForChange;

        const comment = parsed.comment || parsed.creation_comment;

        // Format date if present
        const formattedDate = parsed.date 
          ? new Date(parsed.date).toLocaleString() 
          : null;

        const parts = [
          comment && `comment: ${comment}`,
          formattedDate && `Date: ${formattedDate}`
        ].filter(Boolean);

        return parts.length > 0 ? parts.join(", ") : "-";
      } catch {
        return reasonForChange;
      }
    };

    const emailParams = {
      emails: toEmails,
      templateId: "sdp_email_notification",
      templateData: JSON.stringify({
        emailSubject:
          status === "approved"
            ? "Approved for CoolCloud Test"
            : status === "productionApprovalRequested"
            ? "Request for Production Approval"
            : status === "production"
            ? "Push to CoolCloud and AMS Production"
            : status === "reassigned"
            ? "Re-assign"
            : status === "rejected"
            ? "Rejected"
            : "Shared Data Update",
        userName: userNameToUse,
        cc: ccEmails,
        fromEmail: fromEmail,
        date: new Date().toLocaleDateString(),
        modelNumber: item?.ModelNumber || "Unknown",
        reasonForChange:
          status === "rejected"
            ? (() => {
                let rfc = item?.ReasonForChange;
                let extracted = "-";
                try {
                  if (typeof rfc === "string") rfc = JSON.parse(rfc);
                  if (rfc && rfc.rejection && rfc.rejection.rejection_comment) {
                    extracted = rfc.rejection.rejection_comment;
                  }
                } catch (e) {
                  console.log("[EMAIL DEBUG] Error parsing ReasonForChange:", e);
                }
                return extracted;
              })()
            : status === "approved"
            ? "Approved by Reviewer"
            : formatReasonForChange(item?.ReasonForChange),
        userInputs: changedFields,
        changesDoneTo:
          status === "approved"
            ? "The product has been approved for test in CoolCloud app."
            : status === "productionApprovalRequested"
            ? "Production approval has been requested for the tested product."
            : status === "production"
            ? "The product has been successfully pushed to CoolCloud and AMS Production."
            : status === "reassigned"
            ? "The product review request has been reassigned."
            : status === "rejected"
            ? "The submitted product has been rejected."
            : ""
      })
    };
    dispatch(sendSdpEmailNotification(emailParams));
  };

  const rejectActionItem = async () => {
    lastSelfActionTimeRef.current = Date.now();
    await deleteSdUserInputs();
    await deleteProduct();

    // Build ReasonForChange as a nested object with rejection info
    let prevReason = {};
    try {
      if (typeof actionItem?.ReasonForChange === "string") {
        prevReason = JSON.parse(actionItem.ReasonForChange);
      } else if (typeof actionItem?.ReasonForChange === "object") {
        prevReason = actionItem.ReasonForChange;
      }
    } catch { prevReason = {}; }

    const reasonForChangeObj = {
      creation_comment: prevReason.creation_comment || prevReason.comment || "",
      date: prevReason.date || new Date().toISOString(),
      status: "rejected",
      rejection: {
        rejection_comment: rejectionReason,
        rejectedAt: new Date().toISOString(),
        rejectedBy: {
          name: currentUser?.name || "",
          email: currentUser?.email || ""
        }
      }
    };

    const payload = {
      input: {
        id: actionItem.id,
        Status: "REJECTED",
        ReasonForChange: JSON.stringify(reasonForChangeObj),
      },
    };

    await sharedDataApi.updateActionItems(payload);

    // Fetch the updated action item to get the latest ReasonForChange
    let updatedActionItem = actionItem;
    try {
      const refreshed = await sharedDataApi.getActionItemById(actionItem.id);
      if (refreshed) updatedActionItem = refreshed;
    } catch (e) {
      console.log("[EMAIL DEBUG] Failed to fetch updated action item:", e);
    }

    // Send rejection email after DB update, passing the updated action item
    await sendReviewEmailNotification("rejected", rejectionReason, updatedActionItem);
  };

  const deleteProduct = async () => {
    const payload = {
      input: {
        id: actionItem.ProductId,
        ModelNumber: actionItem.ModelNumber,
      },
    };

    await productApi.deleteProduct(payload);
  };

  const deleteSdUserInputs = async () => {
    const userInputs = getAllSdUserInput();
    for (let i = 0; i < userInputs.length; i++) {
      const params = {
        input: {
          ModelNumber: actionItem.ModelNumber,
          id: userInputs[i].id,
        },
      };
      await sharedDataApi.deleteSdpRecipeInput(params);
    }
  };

  const getAllSdUserInput = async () => {
    const params = {
      filter: {
        or: [
          {
            State: {
              eq: sdStates.production,
            },
            ModelNumber: {
              eq: actionItem.ModelNumber,
            },
          },
          {
            State: {
              eq: sdStates.staging,
            },
            ModelNumber: {
              eq: actionItem.ModelNumber,
            },
          },
          {
            State: {
              eq: sdStates.preProd,
            },
            ModelNumber: {
              eq: actionItem.ModelNumber,
            },
          },
          {
            State: {
              eq: sdStates.draft,
            },
            ModelNumber: {
              eq: actionItem.ModelNumber,
            },
          },
        ],
      },
      limit: 1000,
    };
    let allItems = [];
    let nextToken = null;

    try {
      do {
        const response = await sharedDataApi.fetchUserInputs({
          ...params,
          nextToken,
        });

        const items = response?.items || response?.data?.listSdpRecipeInputs?.items || [];
        allItems = [...allItems, ...items];
        nextToken = response?.nextToken || response?.data?.listSdpRecipeInputs?.nextToken;
      } while (nextToken);

      return allItems;
    } catch (error) {
      console.error("Error fetching paginated SdUserInputs:", error);
      return [];
    }
  };

  const approveActionItem = async (expiryDays) => {
    console.log("Expiry Days Selected:", expiryDays);
    // Step 1: Call CoolCloud API first
    lastSelfActionTimeRef.current = Date.now();
    let coolCloudSuccess = false;
    try {
      const userInput = actionItem.Input ? JSON.parse(actionItem.Input) : {};
      const coolCloudResult = await executeCoolCloudOperations(
        actionItem,
        productData,
        recipeData,
        userInput,
        expiryDays,
        currentUser?.email
      );
      console.log("CoolCloud API result:", coolCloudResult);
      // Consider success if no error flag returned
      coolCloudSuccess = !(coolCloudResult && coolCloudResult.error);
    } catch (error) {
      console.error("Error calling CoolCloud API:", error);
      coolCloudSuccess = false;
    }

    if (!coolCloudSuccess) {
      // CoolCloud failed — do not change state or status
      alert("CoolCloud data push failed. Status and state have not been changed.");
      return;
    }

    // Step 2: CoolCloud succeeded — deploy to staging and update action item
    await deployToStaging(null, expiryDays);

    const payload = {
      input: {
        id: actionItem.id,
        Status: "APPROVED",
        State: "Staging",
      },
    };

    await sharedDataApi.updateActionItems(payload);

    // Step 3: Send approval email
    await sendReviewEmailNotification("approved");
  };

  const deployToStaging = async (versionNumber, expiryDays) => {
    const existingEntries = await sharedDataApi.fetchModelNumberByState({
      ModelNumber: actionItem.ModelNumber,
      id: actionItem.ProductId,
      State: { eq: sdStates.staging },
      filter: { Version: { eq: versionNumber } },
      limit: 10000,
    });

    if (existingEntries.items.length === 0) {
      const params = {
        input: {
          ModelNumber: actionItem.ModelNumber,
          id: actionItem.ProductId,
          Input: JSON.stringify(JSON.parse(actionItem.Input)),
          State: sdStates.staging,
          Version: 0,
          // ReasonForChange: "Creation of shared Data",
          ReasonForChange: actionItem.ReasonForChange,
          ExpiryDays: expiryDays ? parseInt(expiryDays, 10) : null,
        },
      };
      await sharedDataApi.createSdUserInputs(params);
    } else {
      // Update existing entry with expiry days
      const existingEntry = existingEntries.items[0];
      const updateParams = {
        input: {
          id: existingEntry.id,
          ModelNumber: actionItem.ModelNumber,
          ExpiryDays: expiryDays ? parseInt(expiryDays, 10) : null,
        },
      };
      await sharedDataApi.updateSdUserInputs(updateParams);
    }

    await updateProductState();
  };

  const updateProductState = async (state) => {
    lastSelfActionTimeRef.current = Date.now();
    const payload = {
      input: {
        id: actionItem.ProductId,
        State: state || sdStates.staging,
        SdAvailable: true,
        StagingVersion: 0,
        ModelNumber: actionItem.ModelNumber,
        AMSAck: state === sdStates.production ? true : false,
      },
    };

    await productApi.updateProductData(payload);
  };


  const handleRequestProductionApproval = async () => {
    lastSelfActionTimeRef.current = Date.now();
    try {
      await dispatch(requestProductionApproval({ actionItem, getAllSdUserInput }));
      // await fetchActionItemDetails();
      // await loadProductInfo();
    } catch {
      // Error toast is already dispatched by the thunk
    }
  };

  const confirmAction = (action) => {
    const text = 
    action === "reject"
      ? `Are you sure you want to reject this action item?`
      : `Are you sure you want to ${action} this action item and send it to CoolCloud DB for testing?`;

    setShowWarning(false);
    setExpiryDays("");
    setPopupAction(action); // "approve" or "reject"
    setPopupText(text);
    setShowPopup(true);
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

const handlePushToProduction = async () => {
  lastSelfActionTimeRef.current = Date.now();
  
  const result = await dispatch(
    pushToProduction({
      actionItem,
      productData,
      recipeData,
      getAllSdUserInput
    })
  );

  if (result?.success) {
    // Both APIs succeeded
    setMoveToProductionDisabled(true);
    setMoveToProductionResult({ 
      success: true, 
      message: result.message 
    });

    // Update RecipeInput state to Production
    await sharedDataApi.updateSdUserInputs({
      input: {
        id: result.recipeId,
        ModelNumber: actionItem.ModelNumber,
        Input: JSON.stringify(JSON.parse(actionItem.Input)),
        State: sdStates.production,
        Version: 0,
        ReasonForChange: actionItem.ReasonForChange,
      },
    });

    // Update Product state to Production with both acknowledgments
    await productApi.updateProductData({
      input: {
        id: actionItem.ProductId,
        ModelNumber: actionItem.ModelNumber,
        State: sdStates.production,
        CoolCloudDBAck: true,
        AMSAck: true,
      },
    });

    // Update ActionItem state to Production
    await sharedDataApi.updateActionItems({
      input: {
        id: actionItem.id,
        Status: "APPROVED",
        State: "Production",
      },
    });

    // Send single email notification
    await sendReviewEmailNotification("production");
  } else {
    // One or both failed
    setMoveToProductionDisabled(false);
    setMoveToProductionResult({
      success: false,
      message: result?.message || "Push to Production failed. Please try again or contact support."
    });
  }
};


const confirmPushToProduction = () => {
  const text = `Do you want to push ${actionItem.ModelNumber} to Production (CoolCloud & AMS)?`;
  setPopupAction("pushToProduction");
  setPopupText(text);
  setShowPopup(true);
};

  const confirmRequestReAssign = () => {
    setPopupAction("requestReAssign");
    setPopupText(`Request Re-Assignment for ${actionItem.ModelNumber} ?`);
    setShowPopup(true);
  };

  const confirmRequestProductionApproval = () => {
    setPopupAction("requestProductionApproval");
    setPopupText(`Request Production Approval for ${actionItem.ModelNumber} ?`);
    setShowPopup(true);
  };


  return (
    <div className={styles.body}>
      <Helmet>
        <title>Shared Data Portal | Review</title>
      </Helmet>
      <div className={styles.pageNameContainer}>
        <div className={styles.pageName}>Review</div>
        <Breadcrumbs />
      </div>
      <div className={styles.list}>
        <h2>{productData.ModelNumber}</h2>
        <div className={styles.buttonSection}>
          <div className={styles.buttonContainer}>
            {/* <Link to="/dashboard"> */}
            <Link to={`/dashboard?tab=${tab}`}>
              <Button style={styles.backButton}>
                <span>
                  <RiArrowGoBackFill className={styles.icon} />
                  Back
                </span>
              </Button>
            </Link>
          </div>

          <div className={styles.actionButtonsContainer}>
            {currentUser.email === actionItem.CreatedByEmail &&
            actionItem.Status === "IN_REVIEW" ? (
              <Button style={styles.updateButton} onClick={updateProductSD}>
                <span>
                  <RxUpdate className={styles.icon} /> Update Product
                </span>
              </Button>
            ) : (
              <></>
            )}

            {Array.isArray(actionItem.ReviewerEmails) &&
            actionItem.ReviewerEmails.map(e => e.toLowerCase()).includes(currentUser.email.toLowerCase()) &&
            actionItem.Status === "IN_REVIEW" ? (
              <>
                <Button
                  style={styles.approveButton}
                  onClick={() => confirmAction("approve")}
                >
                  <span>
                    <AiOutlineCheckCircle className={styles.icon} /> Approve for CoolCloud Test
                  </span>
                </Button>

                <Button
                  style={styles.rejectButton}
                  onClick={() => confirmAction("reject")}
                >
                  <span>
                    <AiOutlineCloseCircle className={styles.icon} /> Reject
                  </span>
                </Button>
              </>
            ) : (
              <></>
            )}

            {actionItem.Status === "APPROVED" &&
            currentUser.email === actionItem.CreatedByEmail &&
            productData.State === sdStates.staging ? (
              <>
                <Button
                  style={styles.updateButton}
                  onClick={() => {
                    const actionId = searchParam.get("id");
                    navigate(`/products/update-shared-data?id=${actionItem.ProductId}&actionId=${actionId}`);
                  }}
                >
                  <span>
                    <RxUpdate className={styles.icon} /> Re-edit
                  </span>
                </Button>
                <Button
                  style={styles.approveButton}
                  onClick={() => confirmRequestProductionApproval()}
                >
                  <span>
                    <AiOutlineCheckCircle className={styles.icon} /> Request for production approval
                  </span>
                </Button>
              </>
            ) : (
              <></>
            )}

            {Array.isArray(actionItem.ReviewerEmails) &&
            actionItem.ReviewerEmails.map(e => e.toLowerCase()).includes(currentUser.email.toLowerCase()) &&
            currentUser.roles.indexOf("admin") !== -1 &&
            actionItem.Status === "APPROVED" &&
            (productData.State === sdStates.preProd || productData.State === sdStates.production) ? (
              <>
                {productData.State === sdStates.preProd && (
                  <Button
                     style={styles.updateButton}
                     onClick={confirmRequestReAssign}
                   >
                     <span>
                       <RxUpdate className={styles.icon} /> Re-assign
                     </span>
                   </Button>
                )}

                {(!productData.CoolCloudDBAck || !productData.AMSAck) && (
                  <Button
                    style={styles.approveButton}
                    onClick={confirmPushToProduction}
                    disabled={moveToProductionDisabled}
                  >
                    <span>
                      <AiOutlineCheckCircle className={styles.icon} /> Push to CoolCloud and AMS Production
                    </span>
                  </Button>
                )}
              </>
            ) : (
              <></>
            )}
          </div>
        </div>

        {Object.keys(data).map((key) => (
          <RenderData key={key} data={data[key]} label={key.trim()} />
        ))}
      </div>
      {showRejectionPopup && actionItem?.id && (
        <Popup
          title={
            <>
              <b>This action item was rejected.</b>
            </>
          }
          description={
            <>
              <p className={styles.summaryInputHeader}>
                Reason for Rejection
              </p>
              <p className={styles.rejectionText}>
                {(() => {
                  let reasonForChange = actionItem?.ReasonForChange || "";
                  let rejectionReason = "No reason provided";
                  try {
                    let obj = reasonForChange;
                    if (typeof reasonForChange === "string") {
                      obj = JSON.parse(reasonForChange);
                    }
                    if (obj && obj.rejection && obj.rejection.rejection_comment) {
                      rejectionReason = obj.rejection.rejection_comment;
                    }
                  } catch {}
                  return rejectionReason.trim() || "No reason provided";
                })()}
              </p>
            </>
          }
          successText="OK"
          cancelText={null} //This hides the Cancel button
          onSuccess={() => {
            setShowRejectionPopup(false);
            navigate("/dashboard?tab=completed");
          }}
        />
      )}

      {showPopup && (
        <Popup
          title={
            <>
              <b>{popupText}</b>
            </>
          }
          description={
            // popupAction !== "reject" ? (
            popupAction === "approve" ? (
              <>
              <p>Click 'Yes' to confirm or 'Cancel' to go back.</p>
              <div style={{ marginTop: "15px" }}>
                <p className={styles.summaryInputHeader}>Expiry Time (Days)
                  <span className={styles.RejectionStar}> *</span>
                </p>
                <input
                type="number"
                min="1"
                value={expiryDays}
                onChange={(e) => {
                  setExpiryDays(e.target.value);
                  setShowWarning(false);
                }}
                placeholder="Enter expiry time in days"
                className={styles.expiryInput}
                />
                </div>
                </>
            ) : popupAction !== "reject" ? (
              "Click 'Yes' to confirm or 'Cancel' to go back."
            ) : (
              <>
                <p className={styles.RejectionSummaryInputHeader}>
                  Reason for Rejection{" "}
                  <span className={styles.RejectionStar}>*</span>
                </p>
                <textarea
                  name="rejectionReason"
                  className={styles.RejectionSummaryInput}
                  value={rejectionReason}
                  onChange={(e) => {
                    setRejectionReason(e.target.value)
                    setShowWarning(false);
                  }}
                  placeholder="Enter the reason for rejecting this action item."
                />
              </>
            )
          }
          warningMessage={showWarning ? popupAction === "approve" ? "Please enter expiry time in days." : "Please enter a reason for rejection." : null}
          successDisabled={
            popupAction === "approve" &&
            (!expiryDays || Number(expiryDays) <= 0)
          }
          onSuccess={async () => {
            if (popupAction === "reject" && rejectionReason.trim() === "") {
              setShowWarning(true);
              return;
            }
            if (
              popupAction === "approve" &&
              (!expiryDays || Number(expiryDays) <= 0)
            ) {
              setShowWarning(true);
              return;
            }
            switch (popupAction) {
              case "requestProductionApproval":
                await dispatch(
                  requestProductionApproval({
                    actionItem,
                    getAllSdUserInput,
                    onSuccess: () => navigate("/dashboard?tab=outgoing")
                  })
                );
                setShowPopup(false);
                setRejectionReason("");
                setPopupAction(null);
                await sendReviewEmailNotification("productionApprovalRequested");
                return;
                case "pushToProduction":
                await handlePushToProduction();
                break;
              case "approve":
                await approveActionItem(expiryDays);
                break;
              case "reject":
                await rejectActionItem();
                break;
              case "requestReAssign":
                try {
                  lastSelfActionTimeRef.current = Date.now();
                  await dispatch(
                   reAssignToStaging({
                     actionItem,
                     getAllSdUserInput,
                     onSuccess: () => navigate("/dashboard?tab=incoolcloudtest")
                   })
                 );
                  // await fetchActionItemDetails();
                  // await loadProductInfo();
                  
                  setShowPopup(false);
                  setRejectionReason("");
                  setPopupAction(null);
                  await sendReviewEmailNotification("reassigned");
                  return;
                } catch (error) {
                  console.error("Re-assign failed:", error);
                }
                break;
              default:
                break;
            }

            await fetchActionItemDetails();
            await loadProductInfo();

            if (popupAction === "approve") {
              navigate("/dashboard?tab=incoolcloudtest");
              return;
            }

            setShowPopup(false);
            setRejectionReason("");
            setExpiryDays("");
            setPopupAction(null);
          }}
          onCancel={() => {
            setShowPopup(false);
            setRejectionReason("");
            setExpiryDays("");
            setPopupAction(null);
          }}
        />
      )}
      {moveToProductionResult && (
        <Popup
          title={<b>{moveToProductionResult.success ? "Push to Production Success" : "Push to Production Failed"}</b>}
          description={moveToProductionResult.message || (moveToProductionResult.success ?
            "Data has been successfully pushed to CoolCloud and AMS Production." :
            "Push to CoolCloud and AMS Production failed. Please try again or contact support."
          )}
          successText="OK"
          cancelText={null}
          onSuccess={() => {setMoveToProductionResult(null);
            if (moveToProductionResult.success) {
              navigate("/dashboard?tab=completed");
            }}
          }
        />
      )}
    </div>
  );
};

export default ReviewSharedData;
